import { motion } from "framer-motion";
import { ART } from "../assets";

export default function FinalCTA({ onStart }) {
  return (
    <section className="px-5 pb-10 sm:px-8">
      <div className="relative mx-auto max-w-7xl overflow-hidden rounded-[2.5rem] sm:rounded-[3rem] bg-violet grain">
        <div className="pointer-events-none absolute -right-20 -top-24 h-96 w-96 rounded-full bg-violet-deep/60 blur-3xl" />
        <div className="relative grid items-center gap-8 px-7 py-16 sm:px-14 sm:py-20 lg:grid-cols-2 lg:py-24">
          <div>
            <motion.h2
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
              className="font-display text-5xl leading-[0.98] tracking-tight text-white sm:text-6xl lg:text-7xl text-balance"
            >
              Ready to get your space back?
            </motion.h2>
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.9, delay: 0.1 }}
              className="mt-6 max-w-md text-lg text-lavender/90"
            >
              One photo is all it takes. The room you've been missing is closer than you think.
            </motion.p>
            <motion.button
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.9, delay: 0.2 }}
              onClick={onStart}
              data-testid="final-cta-btn"
              className="mt-9 inline-flex items-center gap-3 rounded-full bg-white px-9 py-4 text-base font-semibold text-violet transition-all duration-300 hover:bg-lavender hover:-translate-y-0.5 hover:shadow-[0_18px_40px_-12px_rgba(0,0,0,0.4)]"
            >
              Get an instant quote <span>→</span>
            </motion.button>
          </div>

          <motion.div
            initial={{ opacity: 0, scale: 0.96 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
            className="overflow-hidden rounded-[2rem]"
          >
            <img src={ART.finalCta} alt="A person enjoying their reclaimed space" className="w-full" />
          </motion.div>
        </div>
      </div>
    </section>
  );
}
